export const compact = <T>(
  array: Array<T | null | undefined | false | 0 | ''>,
): T[] => array.filter(Boolean) as T[];
